import { useAuth } from '@platform/auth-client';
import { Button } from '@platform/design-system';
import { ArrowRight, History } from 'lucide-react';
import { SETTINGS_SECTIONS } from '../settings/settings-sections.ts';
import { SettingsSection } from '../settings/SettingsSection.tsx';
import { usePageContext } from '../usePageContext.ts';
import { AUDIT_READ_ROLE } from './history.ts';

export const HistorySection = ({ onOpen }: { onOpen: () => void }) => {
  const { t } = usePageContext();
  const canRead = useAuth().hasRole(AUDIT_READ_ROLE);
  if (!canRead) return null;
  return (
    <SettingsSection
      id={SETTINGS_SECTIONS.history}
      icon={History}
      title={t('history.title')}
      description={t('history.sectionContext')}
      action={
        <Button
          variant="outline"
          icon={<ArrowRight size={20} aria-hidden="true" className="flip-inline" />}
          onClick={onOpen}
        >
          {t('history.openPage')}
        </Button>
      }
    >
      {null}
    </SettingsSection>
  );
};
